<template>
  <div>
    <div class="col-xs-12">
      <p>{{ trans('subscription.exams.explanation_create') }}</p>
    </div>

    <div class="col-xs-12">
      <date-picker-component
        id="date"
        v-model="date"
        :label="trans('core.date')"
      />
    </div>

    <div
      v-if="date != null"
      class="col-xs-12"
      style="margin-top: 5px"
    >
      <div class="form-group">
        <label
          class="control-label col-sm-2"
          for="examSelector"
        >{{ trans('core.exam') }}</label>
        <suggest
          id="examSelector"
          url="/employee/suggest/event-names"
          name="test"
          :placeholder="trans('core.add_object', { 'object': trans('core.exam') }) + '...'"
          div-classes="col-sm-10"
          :include="{ 'type': typeExam, 'on_date': date }"
          :exclude="{ 'id': alreadySubscribableExamNames }"
          data-max-selection="1"
          @select="getExamEvents"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Suggest from './../Suggest.vue'
import DatePickerComponent from '../FormComponents/DatePickerComponent.vue'
import { EXAM } from '@/constants'
import { defaultErrorMessage } from '@/helpers'

export default {

  name: 'SelectExam',
  components: { Suggest, DatePickerComponent },

  data () {
    return {
      alreadySubscribableExamNames: [],
      typeExam: EXAM,
    }
  },

  computed: {
    date: {
      get () {
        return this.$store.state.exams.exam_date
      },
      set (value) {
        return this.$store.dispatch('update_exam_date', value)
      },
    },
  },

  mounted () {
    axios.get('/exam/subscribables/subscribable-exams').then(data => {
      this.alreadySubscribableExamNames = data.data
    }).catch(error => defaultErrorMessage(error))
  },

  methods: {
    getExamEvents (examName) {
      this.$store.dispatch('get_exam_events', examName).then(message => {
        this.$emit('canFinishStep')
      }).catch(error => defaultErrorMessage(error))
    },
  },
}
</script>

<style>
</style>
